import React from 'react';
import { XCircle, ArrowRight } from 'lucide-react';
export function PainPoints() {
  const pains = ['Llegás al patio sin saber exactamente qué rutina vas a dar', 'Tus alumnos no progresan porque no hay un orden claro de cargas y estímulos', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos al mismo tiempo', 'Cuando hay feriado o lluvia perdés la continuidad del entrenamiento y la motivación del grupo', 'No podés justificar un aumento de precio porque no tenés nada sistematizado ni visible', 'Perdés horas cada semana buscando ejercicios en YouTube en lugar de entrenar vos mismo', 'Tus alumnos se estancan y se van porque no sienten que avanzan de verdad'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white border-y border-stone-200" data-id="element-136">
      <div className="max-w-4xl mx-auto" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-138">
          Si sos profe de funcional, esto te va a sonar conocido:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-139">
          {pains.map((pain, index) => <div key={index} className="flex items-start bg-stone-50 p-4 rounded-xl border border-stone-200 shadow-sm" data-id="element-140">
              <XCircle className="w-6 h-6 text-coral-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-141" />
              <p className="text-stone-700 text-lg" data-id="element-142">❌ {pain}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-143">
          <p className="text-2xl font-bold text-stone-900 mb-8 italic" data-id="element-144">
            "¿Cuántas clases más vas a improvisar?"
          </p>
          <a href="#pricing" className="inline-flex items-center justify-center bg-coral-500 hover:bg-coral-600 text-white font-bold text-xl py-4 px-8 rounded-2xl transform transition hover:scale-105 shadow-lg shadow-coral-500/20 w-full sm:w-auto" data-id="element-145">
            👉 BASTA DE IMPROVISAR — QUIERO MI FUNCIONAL 360
          </a>
        </div>
      </div>
    </section>;
}
export function ProductIntro() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-146">
      <div className="inline-block bg-coral-50 text-coral-600 font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider border border-coral-100" data-id="element-147">
        🏆 El Sistema N°1 para Profesores de Funcional Argentinos
      </div>

      <h2 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-6" data-id="element-148">
        FUNCIONAL 360 — Colección Completa
      </h2>

      <h3 className="text-2xl md:text-3xl text-coral-500 font-bold mb-8" data-id="element-149">
        12 Tomos + 6 Bonus + 2 Elite — Todo resuelto, todos los niveles.
      </h3>

      <div className="flex flex-wrap justify-center gap-4 md:gap-12 text-lg font-medium text-stone-600" data-id="element-150">
        <div className="bg-white px-6 py-4 rounded-2xl border border-stone-200 shadow-sm" data-id="element-151">
          <span className="block text-3xl font-bold text-stone-900 mb-1" data-id="element-152">
            +280
          </span>
          páginas
        </div>
        <div className="bg-white px-6 py-4 rounded-2xl border border-stone-200 shadow-sm" data-id="element-153">
          <span className="block text-3xl font-bold text-stone-900 mb-1" data-id="element-154">
            +150
          </span>
          ejercicios graficados
        </div>
        <div className="bg-white px-6 py-4 rounded-2xl border border-stone-200 shadow-sm" data-id="element-155">
          <span className="block text-3xl font-bold text-stone-900 mb-1" data-id="element-156">
            Todos
          </span>
          los niveles
        </div>
      </div>
    </section>;
}